import {registerTemplateGraphNode} from "#template/template-node/register"
import {z} from "zod/v4-mini"
import {TemplateNode} from "#template/template-node/template-node"
import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

export type FixedRotationParameters = {
    x: number
    y: number
    z: number
}

const fixedRotationDefinition: TemplateNodeDefinition<FixedRotationParameters> = {
    nodeClass: "FixedRotation",
    validation: {
        parameters: z.object({x: z.number(), y: z.number(), z: z.number()}),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class FixedRotation extends TemplateNode<FixedRotationParameters> {
    public override get definition() {
        return fixedRotationDefinition
    }
}
